import { RestService, Rest } from '@abp/ng.core';
import type { PagedResultDto } from '@abp/ng.core';
import { Injectable, inject } from '@angular/core';
import type { DownloadTokenResultDto, GetByIdsInputDto } from '../dtos/shared/models';
import type { GetWoodStatementsInputDto, WoodStatementCreateDto, WoodStatementDto, WoodStatementExcelDownloadDto, WoodStatementUpdateDto } from '../dtos/wood-statement/models';

@Injectable({
  providedIn: 'root',
})
export class WoodStatementService {
  private restService = inject(RestService);
  apiName = 'Planning';
  

  create = (input: WoodStatementCreateDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, WoodStatementDto>({
      method: 'POST',
      url: '/api/planning/woodStatements',
      body: input,
    },
    { apiName: this.apiName,...config });
  

  delete = (id: number, config?: Partial<Rest.Config>) =>
    this.restService.request<any, void>({
      method: 'DELETE',
      url: `/api/planning/woodStatements/${id}`,
    },
    { apiName: this.apiName,...config });
  

  deleteByIds = (ids: number[], config?: Partial<Rest.Config>) =>
    this.restService.request<any, void>({
      method: 'DELETE',
      url: '/api/planning/woodStatements',
      params: { ids },
    },
    { apiName: this.apiName,...config });
  

  get = (id: number, config?: Partial<Rest.Config>) =>
    this.restService.request<any, WoodStatementDto>({
      method: 'GET',
      url: `/api/planning/woodStatements/${id}`,
    },
    { apiName: this.apiName,...config });
  

  getDownloadToken = (config?: Partial<Rest.Config>) =>
    this.restService.request<any, DownloadTokenResultDto>({
      method: 'GET',
      url: '/api/planning/woodStatements/download-token',
    },
    { apiName: this.apiName,...config });
  

  getList = (input: GetWoodStatementsInputDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, PagedResultDto<WoodStatementDto>>({
      method: 'GET',
      url: '/api/planning/woodStatements',
      params: { name: input.name, isCursorPaging: input.isCursorPaging, includeTotalCount: input.includeTotalCount, id: input.id, idFrom: input.idFrom, idTo: input.idTo, creationTime: input.creationTime, creationTimeFrom: input.creationTimeFrom, creationTimeTo: input.creationTimeTo, creatorId: input.creatorId, lastModificationTime: input.lastModificationTime, lastModificationTimeFrom: input.lastModificationTimeFrom, lastModificationTimeTo: input.lastModificationTimeTo, lastModifierId: input.lastModifierId, deletionTime: input.deletionTime, deletionTimeFrom: input.deletionTimeFrom, deletionTimeTo: input.deletionTimeTo, deleterId: input.deleterId, sorting: input.sorting, skipCount: input.skipCount, maxResultCount: input.maxResultCount },
    },
    { apiName: this.apiName,...config });
  

  getListAsExcelFile = (input: WoodStatementExcelDownloadDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, Blob>({
      method: 'GET',
      responseType: 'blob',
      url: '/api/planning/woodStatements/as-excel-file',
      params: { downloadToken: input.downloadToken, fields: input.fields, name: input.name, isCursorPaging: input.isCursorPaging, includeTotalCount: input.includeTotalCount, id: input.id, idFrom: input.idFrom, idTo: input.idTo, creationTime: input.creationTime, creationTimeFrom: input.creationTimeFrom, creationTimeTo: input.creationTimeTo, creatorId: input.creatorId, lastModificationTime: input.lastModificationTime, lastModificationTimeFrom: input.lastModificationTimeFrom, lastModificationTimeTo: input.lastModificationTimeTo, lastModifierId: input.lastModifierId, deletionTime: input.deletionTime, deletionTimeFrom: input.deletionTimeFrom, deletionTimeTo: input.deletionTimeTo, deleterId: input.deleterId, sorting: input.sorting, skipCount: input.skipCount, maxResultCount: input.maxResultCount },
    },
    { apiName: this.apiName,...config });
  

  getListByIds = (input: GetByIdsInputDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, WoodStatementDto[]>({
      method: 'GET',
      url: '/api/planning/woodStatements/by-ids',
      params: { ids: input.ids },
    },
    { apiName: this.apiName,...config });
  

  update = (id: number, input: WoodStatementUpdateDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, WoodStatementDto>({
      method: 'PUT',
      url: `/api/planning/woodStatements/${id}`,
      body: input,
    },
    { apiName: this.apiName,...config });
}